const generateSrcset = (image, widths = []) => {
	if (!image["src"]) return "";
	const imageUrl = new URL(image["src"]);
	const maxWidth = image["width"] || Infinity;
	return widths
		.filter((width) => width <= maxWidth)
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"] ?? image;
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

// Adapter so a flat product.images entry (string URL or object) can be used the same as featured_media
const mediaFromProductImage = (img) => {
	let src = typeof img === "string" ? img : img.src;
	// Shopify returns protocol-relative URLs (//cdn.shopify.com/...) — ensure https:
	if (src && src.startsWith("//")) src = "https:" + src;
	const width = typeof img === "string" ? null : (img.width || null);
	const height = typeof img === "string" ? null : (img.height || null);
	return {
		alt: typeof img === "string" ? "" : (img.alt || ""),
		preview_image: { src, width, height },
		src,
		width,
		height,
	};
};

// In-memory cache: handle → product JSON promise
const _productCache = {};

const fetchProduct = (handle) => {
	if (!_productCache[handle]) {
		_productCache[handle] = jQuery.getJSON(
			window.Shopify.routes.root + `products/${handle}.js`
		);
	}
	return _productCache[handle];
};

let swatchListenerAdded = false;

const checkSwatches = () => {
	// colorSwatches() is re-run after filtering, load-more and predictive search;
	// adding the listener again each time made one tap swap the image N times.
	if (swatchListenerAdded) return;
	swatchListenerAdded = true;
	// Event delegation: a single listener on document handles swatches in
	// dynamically-injected sections (e.g. product-recommendations async fetch).
	document.addEventListener("click", (event) => {
		const input = event.target.closest(".js-color-swatches input");
		if (!input) return;
		const wrapper = input.closest(".js-color-swatches-wrapper");
		if (!wrapper) return;

		{
			const primaryImage = wrapper.querySelector(".media--first");
			const secondaryImage = wrapper.querySelector(".media--second");
			const handleProduct = wrapper.dataset.product;

			if (input.checked && primaryImage) {
					wrapper
						.querySelectorAll(".js-color-swatches-link")
						.forEach((item) =>
							item.setAttribute("href", input.dataset.variantLink)
						);
					const currentColor = input.value;

					fetchProduct(handleProduct).then(function (product) {
							const currentColorNorm = currentColor.trim().toLowerCase();

							// 1. Prefer a variant that has featured_media explicitly assigned
							const variant = product.variants.find(
								(item) =>
									item.featured_media != null &&
									item.options.some(o => o.trim().toLowerCase() === currentColorNorm)
							);

							// 2. Fall back: find the first product image whose filename matches
							//    the naming convention "<IMAGE_NAME>_color_<COLOR>"
							let mediaToUse = variant ? variant["featured_media"] : null;
							
							if (!mediaToUse) {
								const colorSlug = currentColorNorm.replace(/\s+/g, "-");
								const fallbackImg = product.images.find((img) => {
									const filename = img?.split("/")?.pop()?.split("?")?.[0]?.toLowerCase();
									if (!filename) {
										console.warn(`[product-card] Failed to parse filename for image with color slug: ${colorSlug}`);
										return
									}
									return filename.includes(`_color_${colorSlug}`);
								});
								if (fallbackImg) {
									mediaToUse = mediaFromProductImage(fallbackImg);
								} else {
									console.warn(
										`[product-card] "${handleProduct}" color "${currentColor}": no featured_media and no filename match for "_color_${colorSlug}". Available images:`,
										product.images
									);
									return;
								}
							}

							const newPrimaryImage = createImageElement(
								mediaToUse,
								primaryImage.className,
								primaryImage.sizes,
								product.title
							);

							if (newPrimaryImage.src !== primaryImage.src) {
								let flag = false;
								if (secondaryImage) {
									const secondaryImagePathname = new URL(secondaryImage.src)
										.pathname;
									const newPrimaryImagePathname = new URL(newPrimaryImage.src)
										.pathname;

									if (secondaryImagePathname == newPrimaryImagePathname) {
										primaryImage.remove();
										secondaryImage.classList.remove("media--second");
										secondaryImage.classList.add("media--first");
										flag = true;
									}
								}
								if (flag == false) {
									primaryImage.animate(
										{ opacity: [1, 0] },
										{ duration: 80, easing: "ease-in", fill: "forwards" }
									).finished;
									setTimeout(function () {
										primaryImage.replaceWith(newPrimaryImage);
										newPrimaryImage.animate(
											{ opacity: [0, 1] },
											{ duration: 80, easing: "ease-in" }
										);
										if (secondaryImage) {
											secondaryImage.remove();
										}
									}, 80);
								}
							}
						}
					);
			}
		}
	});
};

function colorSwatches() {
	checkSwatches();
}

(function () {
	colorSwatches();
})();
